module.exports = __webpack_public_path__ + "img/contact_us_illustration.8cc17dc9.svg";